var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: 'Open Sans', sans-serif;\n  font-size: 1.6rem;\n  background-color: ", ";\n  border-radius: 0.4rem;\n  height: 3.6rem;\n  border: 0.1rem solid ", ";\n  box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.16);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  text-align: center;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  margin-left: 0.5rem;\n\n  img {\n    max-width: 2.4rem;\n  }\n"])), _ref => {
  var {
    theme,
    $toggle
  } = _ref;
  return $toggle ? '#e4eef5' : theme.colors.background;
}, _ref2 => {
  var {
    theme,
    $toggle
  } = _ref2;
  return $toggle ? '#06203d' : theme.colors.border;
});